import CourtNotes from './CourtNotes';

export default CourtNotes;
